import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import CommonLayout from '../layouts/CommonLayout';
import { me } from '../../api/MemberApi';
import useAuthStore from '../../store/authStore';
import { login } from '../../api/AuthApi';
import { getRouteByStatus } from "../../MobileRoutes";
import { AlertModal } from "../layouts/AlertModal";

const LoginPage = () => {
  const navigate = useNavigate();
  const authStore = useAuthStore();

  const [loginForm, setLoginForm] = useState({
    phone: '',
    password: ''
  });

  // 모달 상태 관리 (title 제거)
  const [alertState, setAlertState] = useState({ isVisible: false, message: '', callback: null });

  // API 에러 메시지를 안전하게 추출하는 헬퍼 함수
  const getErrorMessage = (error) => {
    if (error.response && error.response.data && error.response.data.message) {
      return error.response.data.message;
    }
    return '오류가 발생했습니다. 잠시 후 다시 시도해주세요.';
  };

  const handleLogin = async () => {
    try {
      const tokenResponse = await login(loginForm.phone, loginForm.password);
      authStore.setToken(tokenResponse.accessToken, tokenResponse.refreshToken);

      const memberResponse = await me(tokenResponse.accessToken);
      authStore.setMember(memberResponse);

      const redirectPath = getRouteByStatus(memberResponse.status);
      navigate(redirectPath);
    } catch (error) {
      setAlertState({ isVisible: true, message: getErrorMessage(error) });
    }
  };

  return (
      <CommonLayout title="로그인">
        <AlertModal
            isVisible={alertState.isVisible}
            message={alertState.message}
            callback={alertState.callback}
            onClose={() => setAlertState({ isVisible: false, message: '', callback: null })}
        />

        <div className="space-y-4 p-4">
          {/* 휴대폰 번호 입력 필드 */}
          <div className="text-sm font-semibold">휴대폰 번호</div>
          <div>
            <input
                type="text"
                placeholder="휴대폰 번호 ( - 없이 입력)"
                value={loginForm.phone}
                onChange={(e) => setLoginForm({ ...loginForm, phone: e.target.value })}
                className="w-full px-4 py-3 border border-gray-300 rounded-lg"
                maxLength="11"
            />
          </div>

          {/* 비밀번호 입력 필드 */}
          <div className="text-sm font-semibold">비밀번호</div>
          <div>
            <input
                type="password"
                placeholder="비밀번호"
                value={loginForm.password}
                onChange={(e) => setLoginForm({ ...loginForm, password: e.target.value })}
                className="w-full px-4 py-3 border border-gray-300 rounded-lg"
            />
          </div>

          {/* 로그인 버튼 */}
          <button
              onClick={handleLogin}
              className="w-full py-3 bg-amber-500 text-white rounded-lg"
          >
            로그인
          </button>

          {/* 구분선 */}
          <div className="flex items-center my-6">
            <div className="flex-1 border-t border-gray-300"></div>
            <div className="px-4 text-sm text-gray-500">또는</div>
            <div className="flex-1 border-t border-gray-300"></div>
          </div>

          {/* 비밀번호를 잊어버렸어요 버튼 */}
          <button className="w-full py-3 text-gray-600"
                  onClick={() => navigate('/app/password-reset')}
          >
            비밀번호를 잊어버렸어요
          </button>
        </div>
      </CommonLayout>
  );
};

export default LoginPage;
